import React, {useEffect, useState} from "react"
import {formatDateDataGrid} from "src/utils/format-date"
import PropTypes from 'prop-types'
import dayjs from "dayjs"
import {DATE_FORMAT_SHOW} from "src/utils/constants"
import DatalakeService from "src/services/datalake-service"
import ParameterPaginationTable from "src/components/table/parameter-pagination-table"

const ParameterEmissaoRendaFixaParametrosTable = (props) => {
    const datalakeService = new DatalakeService()
    const [data, setData] = useState([])
    const [pagination, setPagination] = useState({count: 0, next: null, previous: null})

    useEffect(() => {
        loadData()
    }, [])

    const loadData = () => {
        props.loading(true)
        datalakeService.loadPaginationEndpoint(props.endpoint).then((response) => {
            props.loading(false)

            const {body} = response
            const {results, count, next, previous} = body
            const list = results.map((obj) => ({...obj, id: obj.ID}))

            setPagination({count: count, next: next, previous: previous})
            setData(list)
        }).catch((err) => {
            props.loading(false)
            props.callbackError(err)
        }).finally(() => {
            props.loading(false)
        })
    }


    const updateRow = async (newRow) => {
        const {
            ID,
            RendaFixaCaracteristicasID,
            IDEmissao,
            DataReferencia,
            VersaoDocumento,
            CETIP,
            TipoAtivo,
            Indexador,
            LiquidezDiaria,
            ValorNominal,
            DataEmissao,
            DataPrimeiraIntegralizacao,
            DataVencimento,
            FrequenciaJuros,
            FrequenciaAmortizacao,
            DataRentabilidadeInicio,
            DataRentabilidadeFim,
            DataInicioPagamentoJuros,
            DataInicioPagamentoAmortizacao,
            DataCarenciaRecompra,
            FrequenciaRecompra,
            IndexadorCorrecaoPercentual,
            Defasagem,
            CalculoDiasIndexador,
            FormulaIndexador,
            CalculoDias,
            JurosCapitalizacao,
            PeriodicidadeAtualizacaoMonetaria,
            MesAniversarioAnualSemestral,
            ProjecaoInflacao,
            InflacaoNegativa,
            RecalculoProjecao,
            AplicacaoAmortizacao,
            CorrigeDataEvento,
            TaxaJuros,
            CalculoFatorJuros,
            CasasFatorJuros,
            CalculoJuros,
            CasasJuros,
            CalculoFatorCorrecao,
            CasasFatorCorrecao,
            CalculoCorrecao,
            CasasCorrecao,
            CalculoFatorJurosCDI,
            CasasFatorJurosCDI,
            CalculoVNA,
            CasasVNA,
            CalculoFatorDesconto,
            CasasFatorDesconto,
            CalculoFatorExpectativa,
            CasasFatorExpectativa,
            CalculoPU,
            CasasPU,
            Inativo
        } = newRow

        const body = {
            "RendaFixaCaracteristicasID": RendaFixaCaracteristicasID,
            "IDEmissao": IDEmissao,
            "DataReferencia": DataReferencia,
            "VersaoDocumento": VersaoDocumento,
            "CETIP": CETIP,
            "TipoAtivo": TipoAtivo,
            "Indexador": Indexador,
            "LiquidezDiaria": LiquidezDiaria,
            "ValorNominal": ValorNominal,
            "DataEmissao": DataEmissao,
            "DataPrimeiraIntegralizacao": DataPrimeiraIntegralizacao,
            "DataVencimento": DataVencimento,
            "FrequenciaJuros": FrequenciaJuros,
            "FrequenciaAmortizacao": FrequenciaAmortizacao,
            "DataRentabilidadeInicio": DataRentabilidadeInicio,
            "DataRentabilidadeFim": DataRentabilidadeFim,
            "DataInicioPagamentoJuros": DataInicioPagamentoJuros,
            "DataInicioPagamentoAmortizacao": DataInicioPagamentoAmortizacao,
            "DataCarenciaRecompra": DataCarenciaRecompra,
            "FrequenciaRecompra": FrequenciaRecompra,
            "IndexadorCorrecaoPercentual": IndexadorCorrecaoPercentual,
            "Defasagem": Defasagem,
            "CalculoDiasIndexador": CalculoDiasIndexador,
            "FormulaIndexador": FormulaIndexador,
            "CalculoDias": CalculoDias,
            "JurosCapitalizacao": JurosCapitalizacao,
            "PeriodicidadeAtualizacaoMonetaria": PeriodicidadeAtualizacaoMonetaria,
            "MesAniversarioAnualSemestral": MesAniversarioAnualSemestral,
            "ProjecaoInflacao": ProjecaoInflacao,
            "InflacaoNegativa": InflacaoNegativa,
            "RecalculoProjecao": RecalculoProjecao,
            "AplicacaoAmortizacao": AplicacaoAmortizacao,
            "CorrigeDataEvento": CorrigeDataEvento,
            "TaxaJuros": TaxaJuros,
            "CalculoFatorJuros": CalculoFatorJuros,
            "CasasFatorJuros": CasasFatorJuros,
            "CalculoJuros": CalculoJuros,
            "CasasJuros": CasasJuros,
            "CalculoFatorCorrecao": CalculoFatorCorrecao,
            "CasasFatorCorrecao": CasasFatorCorrecao,
            "CalculoCorrecao": CalculoCorrecao,
            "CasasCorrecao": CasasCorrecao,
            "CalculoFatorJurosCDI": CalculoFatorJurosCDI,
            "CasasFatorJurosCDI": CasasFatorJurosCDI,
            "CalculoVNA": CalculoVNA,
            "CasasVNA": CasasVNA,
            "CalculoFatorDesconto": CalculoFatorDesconto,
            "CasasFatorDesconto": CasasFatorDesconto,
            "CalculoFatorExpectativa": CalculoFatorExpectativa,
            "CasasFatorExpectativa": CasasFatorExpectativa,
            "CalculoPU": CalculoPU,
            "CasasPU": CasasPU,
            "Inativo": Inativo
        }

        props.loading(true)
        return datalakeService.updateTableEndpoint(props.endpoint, ID, body).then(() => {
            props.loading(false)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const onFilter = async (filterList, limit, offset) => {
        const query = filterList.map(obj => `${encodeURIComponent(obj.field)}=${encodeURIComponent(obj.value)}`).join('&')

        props.loading(true)
        datalakeService.loadPaginationEndpoint(props.endpoint, query, limit, offset).then((response) => {
            props.loading(false)
            const {body} = response
            const {results, count, next, previous} = body
            const list = results.map((obj) => ({...obj, id: obj.ID}))
            setPagination({count: count, next: next, previous: previous})
            setData(list)
        })
    }

    const changePage = async (endpoint) => {
        props.loading(true)
        datalakeService.paginate(endpoint).then((response) => {
            props.loading(false)
            const {body} = response
            const {results, count, previous, next} = body
            const list = results.map((obj) => ({...obj, id: obj.ID}))

            setPagination({count: count, next: next, previous: previous})
            setData([])
            setData(list)
        })
    }

    const columns = [
        {
            field: 'ID',
            headerName: '#',
            disableColumnMenu: true,
            disableFilter: true,
            flex: true,
            minWidth: 80,
        },
        {
            field: 'RendaFixaCaracteristicasID',
            headerName: 'RendaFixaCaracteristicasID',
            flex: 1,
            minWidth: 150,
            type: 'number',
            disableColumnMenu: true,
            editable: false
        },
        {
            field: 'IDEmissao',
            headerName: 'IDEmissao',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: false
        },
        {
            field: 'DataReferencia',
            headerName: 'DataReferencia',
            flex: 1,
            minWidth: 150,
            typeComponent: 'date',
            disableColumnMenu: true,
            editable: true,
            renderCell: (params) => {
                if (!params.value) {
                    return ''
                }
                return dayjs(params.value).format(DATE_FORMAT_SHOW)
            }
        },
        {
            field: 'VersaoDocumento',
            headerName: 'VersaoDocumento',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            type: 'number',
            editable: true
        },
        {
            field: 'CETIP',
            headerName: 'CETIP',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'TipoAtivo',
            headerName: 'TipoAtivo',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'Indexador',
            headerName: 'Indexador',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'LiquidezDiaria',
            headerName: 'LiquidezDiaria',
            flex: 1,
            minWidth: 150,
            type: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'TaxaJuros',
            headerName: 'TaxaJuros',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'ValorNominal',
            headerName: 'ValorNominal',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'DataEmissao',
            headerName: 'DataEmissao',
            flex: 1,
            minWidth: 150,
            typeComponent: 'date',
            disableColumnMenu: true,
            editable: true,
            renderCell: (params) => {
                if (!params.value) {
                    return ''
                }
                return dayjs(params.value).format(DATE_FORMAT_SHOW)
            }
        },
        {
            field: 'DataPrimeiraIntegralizacao',
            headerName: 'DataPrimeiraIntegralizacao',
            flex: 1,
            minWidth: 150,
            typeComponent: 'date',
            disableColumnMenu: true,
            editable: true,
            renderCell: (params) => {
                if (!params.value) {
                    return ''
                }
                return dayjs(params.value).format(DATE_FORMAT_SHOW)
            }
        },
        {
            field: 'DataVencimento',
            headerName: 'DataVencimento',
            flex: 1,
            minWidth: 150,
            typeComponent: 'date',
            disableColumnMenu: true,
            editable: true,
            renderCell: (params) => {
                if (!params.value) {
                    return ''
                }
                return dayjs(params.value).format(DATE_FORMAT_SHOW)
            }
        },
        {
            field: 'DataRentabilidadeInicio',
            headerName: 'DataRentabilidadeInicio',
            flex: 1,
            minWidth: 150,
            typeComponent: 'date',
            disableColumnMenu: true,
            editable: true,
            renderCell: (params) => {
                if (!params.value) {
                    return ''
                }
                return dayjs(params.value).format(DATE_FORMAT_SHOW)
            }
        },
        {
            field: 'DataRentabilidadeFim',
            headerName: 'DataRentabilidadeFim',
            flex: 1,
            minWidth: 150,
            typeComponent: 'date',
            disableColumnMenu: true,
            editable: true,
            renderCell: (params) => {
                if (!params.value) {
                    return ''
                }
                return dayjs(params.value).format(DATE_FORMAT_SHOW)
            }
        },
        {
            field: 'FrequenciaJuros',
            headerName: 'FrequenciaJuros',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'FrequenciaAmortizacao',
            headerName: 'FrequenciaAmortizacao',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'DataInicioPagamentoJuros',
            headerName: 'DataInicioPagamentoJuros',
            flex: 1,
            minWidth: 150,
            typeComponent: 'date',
            disableColumnMenu: true,
            editable: true,
            renderCell: (params) => {
                if (!params.value) {
                    return ''
                }
                return dayjs(params.value).format(DATE_FORMAT_SHOW)
            }
        },
        {
            field: 'DataInicioPagamentoAmortizacao',
            headerName: 'DataInicioPagamentoAmortizacao',
            flex: 1,
            minWidth: 150,
            typeComponent: 'date',
            disableColumnMenu: true,
            editable: true,
            renderCell: (params) => {
                if (!params.value) {
                    return ''
                }
                return dayjs(params.value).format(DATE_FORMAT_SHOW)
            }
        },
        {
            field: 'DataCarenciaRecompra',
            headerName: 'DataCarenciaRecompra',
            flex: 1,
            minWidth: 150,
            typeComponent: 'date',
            disableColumnMenu: true,
            editable: true,
            renderCell: (params) => {
                if (!params.value) {
                    return ''
                }
                return dayjs(params.value).format(DATE_FORMAT_SHOW)
            }
        },
        {
            field: 'FrequenciaRecompra',
            headerName: 'FrequenciaRecompra',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'IndexadorCorrecaoPercentual',
            headerName: 'IndexadorCorrecaoPercentual',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'Defasagem',
            headerName: 'Defasagem',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CalculoDiasIndexador',
            headerName: 'CalculoDiasIndexador',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'FormulaIndexador',
            headerName: 'FormulaIndexador',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CalculoDias',
            headerName: 'CalculoDias',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'JurosCapitalizacao',
            headerName: 'JurosCapitalizacao',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'PeriodicidadeAtualizacaoMonetaria',
            headerName: 'PeriodicidadeAtualizacaoMonetaria',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'MesAniversarioAnualSemestral',
            headerName: 'MesAniversarioAnualSemestral',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'ProjecaoInflacao',
            headerName: 'ProjecaoInflacao',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'InflacaoNegativa',
            headerName: 'InflacaoNegativa',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'RecalculoProjecao',
            headerName: 'RecalculoProjecao',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'AplicacaoAmortizacao',
            headerName: 'AplicacaoAmortizacao',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CorrigeDataEvento',
            headerName: 'CorrigeDataEvento',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CalculoFatorJuros',
            headerName: 'CalculoFatorJuros',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CasasFatorJuros',
            headerName: 'CasasFatorJuros',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CalculoJuros',
            headerName: 'CalculoJuros',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CasasJuros',
            headerName: 'CasasJuros',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CalculoFatorCorrecao',
            headerName: 'CalculoFatorCorrecao',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CasasFatorCorrecao',
            headerName: 'CasasFatorCorrecao',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CalculoCorrecao',
            headerName: 'CalculoCorrecao',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CasasCorrecao',
            headerName: 'CasasCorrecao',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CalculoFatorJurosCDI',
            headerName: 'CalculoFatorJurosCDI',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CasasFatorJurosCDI',
            headerName: 'CasasFatorJurosCDI',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CalculoVNA',
            headerName: 'CalculoVNA',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CasasVNA',
            headerName: 'CasasVNA',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CalculoFatorDesconto',
            headerName: 'CalculoFatorDesconto',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CasasFatorDesconto',
            headerName: 'CasasFatorDesconto',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CalculoFatorExpectativa',
            headerName: 'CalculoFatorExpectativa',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CasasFatorExpectativa',
            headerName: 'CasasFatorExpectativa',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CalculoPU',
            headerName: 'CalculoPU',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CasasPU',
            headerName: 'CasasPU',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'Inativo',
            headerName: 'Inativo',
            flex: 1,
            minWidth: 150,
            typeComponent: 'boolean',
            disableColumnMenu: true,
            editable: false
        },
        {
            field: 'CriadoEm',
            headerName: 'Data de Criação',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        },
        {
            field: 'AtualizadoEm',
            headerName: 'Data de Atualização',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        }
    ]

    return (
        <div>
            <ParameterPaginationTable
                columns={columns}
                data={data}
                setData={setData}
                updateRow={updateRow}
                pagination={pagination}
                onChangePage={changePage}
                filterFunction={onFilter}
                customFilter={true}
                useDeleteButton={false}
            />
        </div>
    )
}

ParameterEmissaoRendaFixaParametrosTable.propTypes = {
    loading: PropTypes.func,
    endpoint: PropTypes.string,
    callbackError: PropTypes.func
}

export default ParameterEmissaoRendaFixaParametrosTable